
import React, {useEffect} from "react";
import { Box, Typography, Button } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useHistory, useParams } from "react-router-dom";

import AccountSidebar from "../../components/general/orderHistory/accountSidebar";
import { getRouteUrl } from "../../helpers/routing/getRouteUrl";
import {
    ROUTE_ADDRESSES,
    ROUTE_COUPONS,
    ROUTE_DETAILS,
    ROUTE_ORDER_HISTORY, ROUTE_RETURNS
} from "../../routers/routes";
import { useAddressData } from "../../hooks/address/useAddressData";
import AddressForm from "../../components/general/addresses/addressForm";
import {useDispatch} from "react-redux";
import {userLogout} from "../../actions/currentUser/actions";
import {useTranslation} from "react-i18next";
import {DASHBOARD} from "../../locales/components/namespaces";
import useCartData from "../../hooks/cart/useCartData";
import {useAddresses} from "../../hooks/address/useAddresses";
import {useLocation} from "react-router";

const AddressEdit = () => {
    const { id } = useParams();
    const location = useLocation();
    const routeCountries = location.state?.countries ?? [];
    const history = useHistory();
    const { formik, loading, isEdit, countries } = useAddressData({
        id,
        initialCountries: routeCountries,
    });
    const { t } = useTranslation(DASHBOARD);
    const dispatch = useDispatch();

    const accountMenuItems = [
        t("accountDetails"),
        t( "orderHistory"),
        t("addresses"),
        t("logout"),
    ];

    const handleLogout = () => {
        dispatch(userLogout());
        history.push(`/`)
    };
    return (
        <Box
            sx={{
                width: "95%",
                //maxWidth: 1760,
                mx: "auto",
                bgcolor: "#E9E9E9",
                borderRadius: "30px",
                px: { xs: 2, md: 6 },
                py: { xs: 4, md: 6 },
            }}
        >
            <Typography
                sx={{
                    fontFamily: "'Zen Maru Gothic', sans-serif",
                    fontWeight: 900,
                    fontSize: { xs: 24, md: 32 },
                    textAlign: "left",
                    textTransform: "uppercase",
                    mb: { xs: 3, md: 4 },
                    color: "#111111",
                }}
            >
                {t('Your address')}
            </Typography>

            <Grid container spacing={{ xs: 3, md: 4 }}>
                <Grid item xs={12} md={3}>
                    <AccountSidebar
                        items={accountMenuItems}
                        activeIndex={2}
                        onSelect={(index) => {
                            if (index === 0) history.push(getRouteUrl(ROUTE_DETAILS));
                            if (index === 1) history.push(getRouteUrl(ROUTE_ORDER_HISTORY));
                            if (index === 2) history.push(getRouteUrl(ROUTE_ADDRESSES));
                            if (index === 3) handleLogout();
                        }}
                    />
                    <Box sx={{ mt: 3 }}>
                        <Button
                            onClick={() =>
                                history.push(getRouteUrl(ROUTE_ADDRESSES))
                            }
                            sx={{
                                mt: 2,
                                boxSizing: "border-box",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                padding: "10px 20px",
                                gap: "1px",
                                width: "118px",
                                height: "37px",
                                border: "1px solid #E5007E",
                                borderRadius: "120px",
                                backgroundColor: "transparent",
                                fontFamily:
                                    "'Roboto Condensed', sans-serif",
                                fontWeight: 700,
                                fontSize: "14px",
                                color: "#E5007E",
                                lineHeight: 1,
                                "&:hover": {
                                    backgroundColor: "#E5007E",
                                    color: "#FFFFFF",
                                    borderColor: "#E5007E",
                                },
                            }}
                        >
                            {t('Return')}
                        </Button>
                    </Box>
                </Grid>

                <Grid item xs={12} md={9}>
                    <Box
                        sx={{
                            bgcolor: "#F0F0F0",
                            borderRadius: "20px",
                            p: { xs: 2, md: 4 },
                            maxWidth: 700,
                        }}
                    >
                        <AddressForm
                            formik={formik}
                            isEdit={isEdit}
                            countryOptions={countries}
                            t={t}
                        />
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default AddressEdit;
